import { render, staticRenderFns } from "./AboutGlovesRatings.vue?vue&type=template&id=7deb5f9a"
import script from "./AboutGlovesRatings.vue?vue&type=script&lang=js"
export * from "./AboutGlovesRatings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports